module.exports = __webpack_public_path__ + "img/canbadge-round-38mm-glitter_line.de817498.png";